import { ChakraComponent, Select, SelectProps, Tooltip } from '@chakra-ui/react';
import { FONT_SIZES } from 'constants/fonts';
import { useTranslation } from 'react-i18next';

/**
 * DROPDOWN FONT SIZE SELECT COMPONENT
 *
 * Renders toolbar font size option with options ranging from MIN_SIZE to MAX_SIZE
 */
interface FontSizeSelectProps extends Omit<SelectProps, 'value'> {
  value: string | typeof FONT_SIZES[number];
}

export const DropdownFontSizeSelect: ChakraComponent<typeof Select, FontSizeSelectProps> = (
  props: FontSizeSelectProps,
) => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false, keyPrefix: 'fontSizeDropdown' });
  const label = t('label');
  const ariaLabel = t('ariaLabel');

  return (
    <Tooltip hasArrow placement='bottom' label={label} bg='black'>
      <Select
        data-testid='fontsize-select'
        width={'80px'}
        size={'sm'}
        aria-label={ariaLabel}
        borderColor='outline.gray'
        {...props}
      >
        {FONT_SIZES.map((value) => (
          <option key={`fontsize-${value}`} value={value}>
            {value}
          </option>
        ))}
      </Select>
    </Tooltip>
  );
};
